/**
 * formatRevenue(value)
 * 금액을 표시용 문자열로 변환한다.
 * - null/undefined → "-"
 * - < 1만 → "₩" + 3자리마다 쉼표
 * - >= 1만 ~ < 1억 → "₩" + 만 단위 + "만"
 * - >= 1억 → "₩" + 억 단위(소수점 1자리) + "억"
 */
export function formatRevenue(value) {
  if (value == null) return "-";

  const absValue = Math.abs(value);
  const isNegative = value < 0;

  if (absValue < 10000) {
    // 1만 미만: "₩" + 3자리마다 쉼표
    const formatted = absValue.toLocaleString("ko-KR");
    return isNegative ? `₩-${formatted}` : `₩${formatted}`;
  }

  if (absValue < 100000000) {
    // 1만 이상 ~ 1억 미만: 만 단위 변환
    const manUnit = Math.round(absValue / 10000);
    const formatted = manUnit.toLocaleString("ko-KR");
    return isNegative ? `₩-${formatted}만` : `₩${formatted}만`;
  }

  // 1억 이상: 억 단위 변환 (소수점 1자리)
  const eokUnit = (absValue / 100000000).toFixed(1);
  return isNegative ? `₩-${eokUnit}억` : `₩${eokUnit}억`;
}

/**
 * formatRevenueWithSign(value)
 * 구독 매출 상세 테이블 전용. formatRevenue에 명시적 +/- 부호를 붙인다.
 * - null/undefined → "-"
 * - > 0 → "+" + formatRevenue(value)
 * - < 0 → formatRevenue(value) (음수 부호 이미 포함)
 * - === 0 → "₩0"
 */
export function formatRevenueWithSign(value) {
  if (value == null) return "-";

  if (value > 0) {
    return "+" + formatRevenue(value);
  }

  if (value < 0) {
    return formatRevenue(value);
  }

  return "₩0";
}
